import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { message } from 'antd';
import axios from '@/api/ai-axios';
import styles from './Other1.module.scss';
import banner from './assets/banner.png';
import { setVisibleNavbarInfo, setVisibleNavbarItem } from '@/reducers/ui';
import useRequest from '@/hooks/useRequest';
import { setLocalStorageExpire } from '@/libs/utils/cookie-tool.js';
import { setUID, setUserData } from '@/reducers/users';
import LoadingSpinner from '@/components/loading-spinner';
import { toggleLoginModal } from '@/reducers/login-pop';
import errorTip from '@/components/navbar/login-modal/error-tip/errorTipManager';
import CryptoJS from 'crypto-js';
import { openBrowser } from '@/libs/utils';

export default function Other1() {
  const navigate = useNavigate();
  const uid = useSelector((state) => state.users.uid);
  const { loadingStates, sendRequest } = useRequest();
  const hasAutoLoggedIn = useRef(false); // 防止重复自动登录

  const setScale = () => {
    let meta = document.querySelector('meta[name=viewport]');
    if (meta) {
      meta.setAttribute('content', 'width=device-width, initial-scale=1');
    }
  };
  const handleCardClick = (path) => {
    if (path === 'wechatMiniProgram') {
      let { VITE_BASENAME, VITE_ORIGIN } = import.meta.env;
      const baseUrl = VITE_ORIGIN + VITE_BASENAME + '/api/mpedu/getJumpticket';
      axios
        .post(`${baseUrl}`, {
          secret: 'zmrobo',
        })
        .then((res) => {
          if (res.data.jump_url) {
            openBrowser(res.data.jump_url + '&temp=' + Math.random(), '_blank');
          }
        });
    } else {
      const fullPath = `/ailab/${path}`;
      if (!path.includes('linearRegression') && uid === '') {
        message.warning('请登录中鸣账号进行体验');
        return;
      }
      navigate(fullPath, {
        state: {
          ifShowApiForm: false,
        },
      });
    }
  };
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setVisibleNavbarItem(false));
    dispatch(setVisibleNavbarInfo(false));
    // 由于此页面是三方体验页，做一个退出页面时清除用户数据的标记。
    localStorage.setItem('clearWhenPageExit', 'true');
  }, []);

  const getCurrentDateTime = () => {
    // 使用服务器时间，避免客户端时间不准
    const now = new Date();
    const utc = now.getTime() + now.getTimezoneOffset() * 60000;
    const beijingTime = new Date(utc + 3600000 * 8);
    const year = beijingTime.getFullYear();
    const month = String(beijingTime.getMonth() + 1).padStart(2, '0');
    const day = String(beijingTime.getDate()).padStart(2, '0');
    const hour = String(beijingTime.getHours()).padStart(2, '0');
    const minute = String(beijingTime.getMinutes()).padStart(2, '0');
    return `${year}${month}${day}${hour}${minute}`;
  };
  let expiresTime = 60 * 24 * 30; // cookie过期时间, 单位：分钟
  const generateMD5 = (str) => {
    return CryptoJS.MD5(str).toString();
  };
  const inputAccount = 'ai_guest@zmrobo.com';
  const inputPassword = '123456';
  useEffect(() => {
    // 防止重复自动登录：只有在uid为空且尚未自动登录过时才执行
    if (!uid && !hasAutoLoggedIn.current) {
      hasAutoLoggedIn.current = true; // 标记已执行自动登录

      const onLogin = async () => {
        try {
          const valueData = 'email';
          const isStudent = false;

          const loginResponse = await performLogin(isStudent, valueData); //抽离统一登录流程
          if (loginResponse.status !== 1) {
            errorTip.error(
              isStudent ? loginResponse.message : '账号或密码错误',
              3000,
            );
            return;
          }

          await handleLoginSuccess(loginResponse.data.uid);
        } catch (error) {
          console.error('登录过程中出现错误:', error);
          return null;
        }
      };

      const performLogin = async (isStudent, valueData) => {
        const encryptedPassword = generateMD5(inputPassword);

        if (!isStudent) {
          // 非学生登录
          const formData = new FormData();
          formData.append('account', inputAccount);
          formData.append('password', encryptedPassword);
          formData.append('auth_type', valueData);

          return await sendRequest(
            {
              method: 'POST',
              url: '/api/login_zm',
              data: formData,
            },
            'loginZMUid',
          );
        } else {
          // 学生登录
          const loginStuForm = new FormData();
          loginStuForm.append('account', inputAccount);
          loginStuForm.append('password', encryptedPassword);

          const currentDateTime = getCurrentDateTime();
          const secretStr = `zmrobo#${currentDateTime}`;
          const encryptedSecret = generateMD5(secretStr);
          loginStuForm.append('secret', encryptedSecret);

          return await sendRequest(
            {
              method: 'POST',
              url: '/api/login_stu',
              data: loginStuForm,
            },
            'loginSTU',
          );
        }
      };

      // 登录成功后的逻辑统一处理
      const handleLoginSuccess = async (uid) => {
        setLocalStorageExpire('uid', uid, expiresTime);
        dispatch(setUID(uid));

        // 获取用户信息
        const userDataForm = new FormData();
        userDataForm.append('secret', 'zmrobo');
        const loginUserData = await sendRequest({
          method: 'POST',
          url: '/api/user/getUserInfo',
          data: userDataForm,
        });

        if (loginUserData.status !== 1) {
          throw new Error(loginUserData.message);
        }

        // message.success('登录成功');

        // await callCozeBeforeAPI(loginUserData.data);
        dispatch(setUserData(loginUserData.data));

        dispatch(toggleLoginModal(false));
      };

      onLogin();
    }
  }, [uid]);

  useEffect(() => {
    window.onorientationchange();
  }, []);

  // Excel文件下载处理函数 - 使用更可靠的下载方法
  const handleExcelDownload = () => {
    const downloadUrl =
      'https://oss.zmrobo.com/ai/cdn/playwithai/chapter1-data.xlsx';
    // 直接在新标签页打开下载链接，避免操作DOM
    window.open(downloadUrl, '_blank');
  };

  // 处理mPython软件下载
  const handleMpythonDownload = () => {
    openBrowser('https://www.mpython.cn/software', '_blank');
  };

  // 处理mxml文件下载
  const handleMxmlDownload = () => {
    const downloadUrl = 'https://oss.zmrobo.com/ai/cdn/playwithai/heka.mxml';
    window.open(downloadUrl, '_blank');
  };

  const handleOpenExternalUrl = (downloadUrl) => {
    window.open(encodeURI(downloadUrl), '_blank');
  };

  const handleSb3Download = () => {
    handleOpenExternalUrl(
      'https://oss.zmrobo.com/ai/cdn/playwithai/人工智能蝴蝶案例.sb3',
    );
  };

  const handleButterflyMxmlDownload = () => {
    const downloadUrl =
      'https://oss.zmrobo.com/ai/cdn/playwithai/手势控制蝴蝶.html';
    const fileName = '手势控制蝴蝶.html';

    fetch(encodeURI(downloadUrl))
      .then((response) => response.blob())
      .then((blob) => {
        const a = document.createElement('a');
        const objectUrl = URL.createObjectURL(blob);

        a.href = objectUrl;
        a.download = fileName;
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
        a.remove();

        URL.revokeObjectURL(objectUrl);
      });
  };

  // 处理第三期编程平台点击
  const handleRoboCodeClick = () => {
    setScale();

    if (uid === '') {
      message.warning('请登录中鸣账号进行体验');
      return;
    }

    openBrowser('https://ai.zmrobo.com/robocodeLite', '_blank');
  };

  // 处理知识点1点击（AI智能问答）
  const handleKnowledge1Click = () => {
    setScale();
    handleCardClick('aiChat');
  };

  // 处理知识点2点击（线性回归训练器）
  const handleKnowledge2Click = () => {
    setScale();
    handleCardClick('linearRegression');
  };

  return (
    <LoadingSpinner
      loading={
        loadingStates['/api/login_zm'] || loadingStates['/api/user/getUserInfo']
      }
    >
      <div className={styles.other1}>
        <img className={styles.banner} src={banner}></img>
        {/* 
        <div className={styles.content1}>
          <img src={content1}></img>
          {filteredProjects.length > 0 && (
            <div className={styles.aiCardsContainer}>
              <div className={styles.aiCardsList}>
                {filteredProjects.map((project) => (
                  <AiLabNavCard
                    className={styles.cardItem}
                    key={project.id}
                    project={project}
                    onClick={() => {
                      setScale();
                      handleCardClick(project.path);
                    }}
                    hasPermission={checkProjectPermission(project.id)}
                  />
                ))}
              </div>
            </div>
          )}
          <div className={styles.excelIcon}>
            <div onClick={handleExcelDownload}>
              <img src={excelIcon} alt="excelIcon" />
              <div>数据表（Excel）下载</div>
            </div>
          </div>
        </div>
        <img className={styles.banner} src={content2}></img> */}

        <div className={styles.cardsContainer}>
          <div className={styles.cardFullRow}>
            <div className={styles.cardTitle}>第三期活动</div>
            <div className={`${styles.card} ${styles.cardThird}`}>
              <div className={`${styles.content} ${styles.contentThird}`}>
                <div className={styles.sections}>
                  <div className={styles.section}>
                    <div className={styles.sectionTitle}>编程平台</div>
                    <button
                      className={`${styles.btn} ${styles.btnOrange}`}
                      onClick={handleRoboCodeClick}
                    >
                      前往
                    </button>
                    <div className={styles.linkText}>进入神奇的编程世界</div>
                  </div>
                  <div className={styles.section}>
                    <div className={styles.sectionTitle}>所需资料</div>
                    <button
                      className={`${styles.btn} ${styles.btnTeal}`}
                      onClick={handleSb3Download}
                    >
                      下载
                    </button>
                    <div className={styles.linkText}>人工智能蝴蝶案例.sb3</div>
                  </div>
                  <div className={styles.section}>
                    <div className={styles.sectionTitle}>所需资料</div>
                    <button
                      className={`${styles.btn} ${styles.btnTeal}`}
                      onClick={handleButterflyMxmlDownload}
                    >
                      下载
                    </button>
                    <div className={styles.linkText}>手势控制蝴蝶.html</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* 第二期活动卡片 */}
          <div>
            <div className={styles.cardTitle}>第二期活动</div>
            <div className={`${styles.card} ${styles.cardSecond}`}>
              <div className={styles.content}>
                <div className={styles.sections}>
                  <div className={styles.section}>
                    <div className={styles.sectionTitle}>软件下载</div>
                    <button
                      className={`${styles.btn} ${styles.btnPrimary}`}
                      onClick={handleMpythonDownload}
                    >
                      前往
                    </button>
                    <div className={styles.linkText}>mPython 掌控板官网</div>
                  </div>
                  <div className={styles.section}>
                    <div className={styles.sectionTitle}>所需资料</div>
                    <button
                      className={`${styles.btn} ${styles.btnSuccess}`}
                      onClick={handleMxmlDownload}
                    >
                      下载
                    </button>
                    <div className={styles.linkText}>智能语音电子贺卡.mxml</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div>
            <div className={styles.cardTitle}>第一期活动</div>
            {/* 第一期活动卡片 */}
            <div className={`${styles.card} ${styles.cardFirst}`}>
              <div className={styles.content}>
                <div className={styles.sections}>
                  <div className={styles.section}>
                    <div className={styles.sectionTitle}>知识点1</div>
                    <button
                      className={`${styles.btn} ${styles.btnBrown}`}
                      onClick={handleKnowledge1Click}
                    >
                      前往
                    </button>
                    <div className={styles.linkText}>线性回归训练器</div>
                  </div>
                  <div className={styles.section}>
                    <div className={styles.sectionTitle}>知识点2</div>
                    <button
                      className={`${styles.btn} ${styles.btnBrown}`}
                      onClick={handleKnowledge2Click}
                    >
                      前往
                    </button>
                    <div className={styles.linkText}>AI 智能问答</div>
                  </div>
                  <div className={styles.section}>
                    <div className={styles.sectionTitle}>所需资料</div>
                    <button
                      className={`${styles.btn} ${styles.btnBlue}`}
                      onClick={handleExcelDownload}
                    >
                      下载
                    </button>
                    <div className={styles.linkText}>数据表Excel</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </LoadingSpinner>
  );
}
